import React from 'react'
import { useTranslation } from 'react-i18next';

const ThankYouHeader = ({ customer, order }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="ThankYouHeader">
      <img src={process.env.PUBLIC_URL + '/NoStock.png'} alt="Order icon" className="HeaderIcon" />
      <div>
        <h3>{t("Thank you")}, {customer}!</h3>
        <h3>Your order {order} has been created</h3>
      </div>
    </div>
  )
}

export default ThankYouHeader